module.exports = __webpack_public_path__ + "img/BBW-Logo-AugustDates.fbbda784.png";